import { render, staticRenderFns } from "./BsTabItem.vue?vue&type=template&id=77e23e3c&scoped=true&"
import script from "./BsTabItem.vue?vue&type=script&lang=js&"
export * from "./BsTabItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e23e3c",
  null
  
)

export default component.exports